import React from 'react';
import PropType from 'prop-types';
import Mage from './Mage';
import Enemies from './Enemies';
import VideoOverlay from '../common/VideoOverlay';


export default class GamePlaySection extends React.Component {
    static propTypes = {
        content: PropType.object
    };
    state= {
        showOverlay: false
    };

    showVideo = () => {
        this.setState({showOverlay: !this.state.showOverlay});
    };

    closeOverlay = () => {
        const el = this.videoContainer.overlay;
        TweenMax.to(el, 0.3, {autoAlpha: 0, ease: Power1.easeOut, onComplete: this.hideOverlay});
    };

    hideOverlay = () => {
        this.setState({showOverlay: false});
    };

    render() {
        const {
            title, subtitle, description, video, videoImg, title1, title2
        } = this.props.content;
        const style = {};
        if (video && videoImg) {
            style.backgroundImage = `url(${videoImg})`
            style.backgroundSize = 'cover'
        }
        return (
            <div ref={(c) => {this.wrapper = c;}} className="game-play-section">
                <div className="background" />
                <div className="mountains" />
                <Enemies />
                <Mage />
                <div className="content-container">
                    <div className="content">
                        <h1>
                            {title1 && title2 ? <>{title1}<br></br>{title2}</> : title}
                        </h1>
                        <div className="description" dangerouslySetInnerHTML={{__html: description}} />
                    </div>
                    <div className="btn-container" style={style}>
                        <div role="presentation" className="btn" onClick={this.showVideo} />
                        <h6 className="text-center offical-play">{subtitle}</h6>
                    </div>
                </div>
                {this.state.showOverlay ? (
                    <VideoOverlay
                        ref={(c) => {this.videoContainer = c;}}
                        video={video}
                        closeOverlay={this.closeOverlay}
                        showOverlay={this.state.showOverlay} />
                ) : null}
            </div>
        );
    }
}

